// extracted by mini-css-extract-plugin
module.exports = {"ControlPanelRoomsList":"ControlPanelRoomsList_ControlPanelRoomsList__33SPz"};